import { useContext, useMemo } from 'react';

import { TrackingContext } from '../../contexts';
import { ElementId, ElementPath } from '../../types';
import { parseElementId } from '../../utils';

export const useElementPath = (elementId: ElementId) => {
  const { role, name } = parseElementId(elementId);
  const { path: scopes } = useContext(TrackingContext);

  const elementPath: ElementPath = useMemo(
    () => [...scopes, { role, name }],
    [scopes, role, name],
  );

  return elementPath;
};
